import { FileDto, FileUploadDto } from './file.dto';
import { UserDto } from './user.dto';
import { IsArray, IsBoolean, IsDate, IsNotEmpty, IsOptional, IsString, IsUUID, MinLength } from 'class-validator';
import { Type } from 'class-transformer';

export class PostDto {
	id: string;
	alias?: string;

	@IsString()
	@IsNotEmpty()
	@MinLength(3)
	title: string;

	@IsString()
	@IsNotEmpty()
	text: string;

	@IsOptional()
	image?: FileDto;

	@IsNotEmpty()
	user: UserDto;

	@IsArray()
	@IsString({ each: true })
	tags: string[];

	@IsDate()
	@Type(() => Date)
	createdAt: Date;

	@IsDate()
	@Type(() => Date)
	updatedAt: Date;

	@IsDate()
	@Type(() => Date)
	publishAt: Date;
}

export class CreatePostDto {
	@IsString()
	@IsNotEmpty()
	@MinLength(3)
	title: string;

	@IsString()
	@IsNotEmpty()
	text: string;

	@IsOptional()
	image?: FileUploadDto;

	userId: string;

	@IsDate()
	@Type(() => Date)
	publishAt: Date;

	@IsArray()
	@IsString({ each: true })
	tags: string[];
}

export class UpdatePostDto extends CreatePostDto {}
